import DataColectors from './DataColectors';

export default DataColectors;
